const reviews = [
  {
    author: 'John Doe',
    stars: 3,
    id: '1234234',
    content: 'Best scrabled eggs you can imagine',
  },
  {
    author: 'Jane Doe',
    stars: 5,
    id: '1234235',
    content: 'Best scrabled eggs you can imagine',
  },
];

export default reviews;
